import "./personalDetailsForest.css";
import React, { useState, useEffect } from "react";

import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import SearchIcon from '@mui/icons-material/Search';
import { typeNumberValid, VALIDATION, nameValidation, mobileNumberValidation, maxNameLength, mobileNoMaxLength, otpMaxLength, addressMaxLength } from "../../../../common/commonValidations";
import { ID_PROOF, PAN_CARD, BANK_CANCELLED_CHEQUE, HARVEST_PLAN, CONSTANTS, LOI_ABRPL_AGREEMENT, BASIC_DATE_FORMAT, API_DATE_FORMAT, EMPTY_FIELD_ERROR, SAVE_EXIT_API, LAND_AREA_UNIT, UPLOAD_FILE_TEXT, SALUTATION, GENDER, REVENUE_CIRCLE, BLOCK_LIST, INVALID_OTP_ERROR, ROLES, BANK_STATEMENT, RESOURCE_ROLES } from "../../../../common/constants";
import { authKey, GET_ADDRESS_BY_IFSC, UPDATE_GROWER, GET_GROWER_BY_URN, UPLOAD_DCUMENT, ResourceUpdateMember } from '../../../../common/URLs'
import resolveIcon from "../../../../images/resolved.png";
import { CommonPincodeMUI } from "../../../../common/common-pincode/commonPincodeMUI";
import jwt from 'jwt-decode';
import { getLocalStorageItem } from "../../../../common/localStorageUtils";
import { PROD } from "../../../../common/constants";
import { appCountDisplay } from '../dashboardStakeHolder';
import { Container, Card, Button, Stack, CardContent, InputAdornment, Divider, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { FileUploadMUI } from "../../../../common/fileUpload/fileUploadMUI";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import "react-datepicker/dist/react-datepicker.css";
import { sendOTP, validateOTP } from '../../../../common/Utils';
import { useTranslation } from "react-i18next";
import BackButton from '../../../../common/backButton';
import { handleNumberFieldFocus } from "../../../../common/commonFunction";
import apiClient from "../../../../axios";
import BadgeComponent from "../../../../common/badge";

const PersonalDetailsForest = (props) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { state } = useLocation();
    const urn = state?.URN ? state.URN : props.urn;
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [otpValue, setOtpValue] = useState();
    const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
    const [otpHidden, setOtpHidden] = useState(true);
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [details, setDetails] = useState({
        mobileNo: "",
        address: "",
        pincode: "",
        state: "",
        district: "",
        revenueCircle: "",
        blockName: "",
        govtIdCardType: "MOA",
        govtIdCardNumber: "",
        otherGovtCardType: "",
        panNumber: null,
        bankAccountNumber: null,
        bankAccountHolderName: null,
        bankBranch: null,
        bankIfscCode: null,
        growerDocuments: "",
        contactPersonSalutation: '',
        contactPersonFirstname: '',
        contactPersonMiddlename: '',
        contactPersonLastname: '',
        contactPersonGender: '',
    });
    const [forestDetails, setForestDetails] = useState();
    const [govIDType, setGovIDType] = useState("MOA");
    const [otherIdType, setOtherIdType] = useState();
    const [updatedDetails, setUpdatedDetails] = useState();
    const [govIDNumber, setGovIDNumber] = useState('');
    const [panNumber, setPanNumber] = useState('');
    const [royaltyCharge, setRoyaltyCharge] = useState('');
    const [fee, setFee] = useState();
    const [editMode, setEditMode] = useState(state?.editmode);
    const [name, setName] = useState('');
    const [contactPersonFirstname, setContactPersonFirstname] = useState('');
    const [contactPersonMiddlename, setContactPersonMiddlename] = useState('');
    const [contactPersonLastname, setContactPersonLastname] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [contactPersonSalutation, setContactPersonSalutation] = useState('');
    const [contactPersonGender, setContactPersonGender] = useState('');
    const [address, setAddress] = useState('');
    const [forestDeptAddress, setForestDeptAddress] = useState('');
    const [pincodeDetails, setPincodeDetails] = useState({
        pincode: '',
        state: '',
        district: '',
        revenueCircle: '',
        blockName: ''
    });
    const [forestDeptpincodeDetails, setForestDeptPincodeDetails] = useState({
        pincode: '',
        state: '',
        district: '',
        revenueCircle: '',
        blockName: ''
    });
    const [forestDeptTotalLandAreaValue, setForestDeptTotalLandAreaValue] = useState('');
    const [forestDeptTotalLandAreaUnit, setForestDeptTotalLandAreaUnit] = useState('');
    const [forestDeptTotalNoOfBambooClumps, setForestDeptTotalNoOfBambooClumps] = useState('');
    const [bankDetails, setBankDetails] = useState();
    const [accountNumber, setAccountNumber] = useState('');
    const [accountHolderName, setAccountHolderName] = useState('');
    const [bankBranch, setbankBranch] = useState('');
    const [ifscCode, setIfscCode] = useState('');
    const [bankName, setBankName] = useState('');
    const [agreementStartDateDisplay, setAgreementStartDateDisplay] = useState();
    console.log("agreementStartDateDisplay", agreementStartDateDisplay)
    const [agreementStartDate, setAgreementStartDate] = useState();
    const [agreementEndDateDisplay, setAgreementEndDateDisplay] = useState();
    const [agreementEndDate, setAgreementEndDate] = useState();
    const [errorMessage, setErrorMessage] = useState({
        nameError: '',
        contactPersonFirstNameError: '',
        contactPersonMiddleNameError: '',
        contactPersonLastNameError: '',
        contactPersonGenderError: '',
        contactPersonSalutationError: '',
        mobileNoError: '',
        addressError: '',
        forestDeptAddressError: '',
        accountNumberError: '',
        accountHolderNameError: '',
        ifscCodeError: '',
        landAreaError: '',
        clumpsError: '',
        govtIDError: '',
        panError: '',
        documentError: '',
        forestDeptPincodeError: '',
        royaltyChargeError: '',
        otherFeeError: '',
        idProofDocError: '',
        panDocError: '',
        bankDocError: '',
        harvestPlanDocError: '',
    });
    const [documentArray, setDocumentArray] = useState([]);
    let userRole = localStorage.getItem('role');
    const bambooSpeciesRes = props.bambooSpeciesRes;

    useEffect(() => {
        if (urn) {
            getForestDetailsFromUrn();
        }
    }, [urn]);
    useEffect(() => {
        if (forestDetails) {
            let docType = forestDetails?.growers[0]?.growerDocuments
            const regStakeholderMaster =
                forestDetails?.growers[0]?.regStakeholderMaster;
            setDetails({
                ...details,
                name: regStakeholderMaster?.name,
                contactPersonSalutation: regStakeholderMaster?.contactPersonSalutation,
                contactPersonFirstname: regStakeholderMaster?.contactPersonFirstname,
                contactPersonMiddlename: regStakeholderMaster?.contactPersonMiddlename,
                contactPersonLastname: regStakeholderMaster?.contactPersonLastname,
                contactPersonGender: regStakeholderMaster?.contactPersonGender,
                address: forestDetails?.growers[0]?.address,
                pincode: forestDetails?.growers[0]?.pincode,
                state: forestDetails?.growers[0]?.state,
                district: forestDetails?.growers[0]?.district,
                revenueCircle: forestDetails?.growers[0]?.revenueCircle,
                blockName: forestDetails?.growers[0]?.blockName,
                mobileNo: regStakeholderMaster?.mobileNo,
                govtIdCardType: regStakeholderMaster?.govtIdCardType,
                govtIdCardNumber: regStakeholderMaster?.govtIdCardNumber,
                otherGovtCardType: regStakeholderMaster?.otherGovtCardType,
                panNumber: regStakeholderMaster?.panNumber,
                growerDocuments: forestDetails?.growers[0]?.growerDocuments,
                forestDeptAddress: forestDetails?.growers[0]?.forestDeptAddress,
                forestDeptPincode: forestDetails?.growers[0]?.forestDeptPincode,
                forestDeptState: forestDetails?.growers[0]?.forestDeptState,
                forestDeptDistrict: forestDetails?.growers[0]?.forestDeptDistrict,
                forestDeptSubDivision: forestDetails?.growers[0]?.forestDeptSubDivision,
                forestDeptRevenueCircle: forestDetails?.growers[0]?.forestDeptRevenueCircle,
                forestDeptBlockName: forestDetails?.growers[0]?.forestDeptBlockName,
                forestDeptPostOffice: forestDetails?.growers[0]?.forestDeptPostOffice,
                forestDeptTotalLandArea: forestDetails?.growers[0]?.forestDeptTotalLandArea,
                forestDeptTotalNoOfBambooClumps: forestDetails?.growers[0]?.forestDeptTotalNoOfBambooClumps,
                registrationCompleted: forestDetails?.growers[0]?.registrationCompleted

            })
            setMobileOTPValidated(regStakeholderMaster.isOtpValidated);
            setAccountNumber(regStakeholderMaster?.bankAccountNumber)
            setAccountHolderName(regStakeholderMaster?.bankAccountHolderName)
            setbankBranch(regStakeholderMaster?.bankBranch)
            setName(regStakeholderMaster?.name);
            setContactPersonFirstname(regStakeholderMaster?.contactPersonFirstname);
            setContactPersonMiddlename(regStakeholderMaster?.contactPersonMiddlename);
            setContactPersonLastname(regStakeholderMaster?.contactPersonLastname);
            setContactPersonGender(regStakeholderMaster?.contactPersonGender);
            setContactPersonSalutation(regStakeholderMaster?.contactPersonSalutation);
            setMobileNo(regStakeholderMaster?.mobileNo);
            setAddress(forestDetails?.growers[0]?.address);
            setForestDeptAddress(forestDetails?.growers[0]?.forestDeptAddress);
            setIfscCode(regStakeholderMaster?.bankIfscCode);
            const spaceIndex = forestDetails?.growers[0]?.forestDeptTotalLandArea?.indexOf(" ");
            const numberPart = forestDetails?.growers[0]?.forestDeptTotalLandArea?.slice(0, spaceIndex);
            const unitPart = forestDetails?.growers[0]?.forestDeptTotalLandArea?.slice(spaceIndex + 1);
            setForestDeptTotalLandAreaValue(numberPart);
            setForestDeptTotalLandAreaUnit(unitPart);
            setForestDeptTotalNoOfBambooClumps(forestDetails?.growers[0]?.forestDeptTotalNoOfBambooClumps);
            setPincodeDetails({ ...pincodeDetails, pincode: forestDetails?.growers[0]?.pincode, state: forestDetails?.growers[0]?.state, district: forestDetails?.growers[0]?.district, revenueCircle: forestDetails?.growers[0]?.revenueCircle, blockName: forestDetails?.growers[0]?.blockName })
            setForestDeptPincodeDetails({ ...forestDeptpincodeDetails, pincode: forestDetails?.growers[0]?.forestDeptPincode, state: forestDetails?.growers[0]?.forestDeptState, district: forestDetails?.growers[0]?.forestDeptDistrict, revenueCircle: forestDetails?.growers[0]?.forestDeptRevenueCircle, blockName: forestDetails?.growers[0]?.forestDeptBlockName })
            setBankName(regStakeholderMaster?.bankName)
            setRoyaltyCharge(forestDetails?.growers[0]?.royaltyCharge)
            setFee(forestDetails?.growers[0]?.anyOtherFee)
            setPanNumber(regStakeholderMaster?.panNumber)
            setGovIDType(regStakeholderMaster?.govtIdCardType ? regStakeholderMaster?.govtIdCardType : "MOA")
            setOtherIdType(regStakeholderMaster?.otherGovtCardType)
            setGovIDNumber(regStakeholderMaster?.govtIdCardNumber)
            setAgreementStartDateDisplay(forestDetails?.growers[0]?.agreementStartDate && moment(forestDetails?.growers[0]?.agreementStartDate).format(BASIC_DATE_FORMAT))
            setAgreementEndDateDisplay(forestDetails?.growers[0]?.agreementEndDate && moment(forestDetails?.growers[0]?.agreementEndDate).format(BASIC_DATE_FORMAT))
            setAgreementStartDate(forestDetails?.growers[0]?.agreementStartDate)
            setAgreementEndDate(forestDetails?.growers[0]?.agreementEndDate)
            setDocumentArray(forestDetails?.growers[0]?.growerDocuments)
        }
    }, [forestDetails]);

    useEffect(() => {
        setUpdatedDetails({
            ...details,
        });
    }, [details]);

    const getUpdatedAddressData = (data) => {
        setUpdatedDetails({
            ...updatedDetails,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,

        })
        setPincodeDetails({
            ...pincodeDetails,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,
        })
    }
    const onUploadCallBack = (docArray) => {
        setDocumentArray(docArray);
    }
    const handleDateChange = (e, name) => {
        let date = e.format(API_DATE_FORMAT);
        let formattedDate = moment(date).format(API_DATE_FORMAT)
        if (name == "agreementStartDate") {
            setAgreementStartDate(formattedDate);
            setAgreementStartDateDisplay(moment(date).format(BASIC_DATE_FORMAT));
        }
        else if (name == "agreementEndDate") {
            setAgreementEndDate(formattedDate);
            setAgreementEndDateDisplay(moment(date).format(BASIC_DATE_FORMAT));
        }
    }
    useEffect(() => {
        if (bankDetails) {
            setUpdatedDetails({
                ...updatedDetails, bankBranch: bankDetails?.branch, bankName: bankDetails?.bank
            });
        }
    }, [bankDetails]);
    const getForestDetailsFromUrn = () => {
        apiClient.post(GET_GROWER_BY_URN,
            {
                "urn": urn,
                "type": "",
                "isScrutinyView": "true"
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
            .then((response) => {
                setForestDetails(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const getBankDetails = () => {
        apiClient
            .post(GET_ADDRESS_BY_IFSC,
                {
                    "ifsc": ifscCode,
                },
                {
                    headers: {
                        AuthKey: authKey,
                    },
                }
            )
            .then((response) => {
                if (response.data.isSuccess === true)
                    setBankDetails(response.data);
                else {
                    setIfscCode("");
                    setbankBranch("");

                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    useEffect(() => {
        if (bankDetails) {
            setbankBranch(bankDetails?.branch)
        }
    }, [bankDetails]);

    const handleChange = (e) => {
        setUpdatedDetails({ ...updatedDetails, [e.target.name]: e.target.value });

        if (e.target.name === 'bankAccountHolderName') {
            setUpdatedDetails({ ...updatedDetails, bankAccountHolderName: VALIDATION.fullNameValidation(e.target.value) });
            if (e.target.value.length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, accountHolderNameError: '' })
            } else setErrorMessage({ ...errorMessage, accountHolderNameError: "Please enter Account Holder's Name" })
        }
        if (e.target.name === 'panNumber') {
            setUpdatedDetails({ ...updatedDetails, [e.target.name]: e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, '') });
            if (e.target.value.length > 0 && VALIDATION.panNumberValidation(e.target.value.toUpperCase())) {
                setErrorMessage({ ...errorMessage, panNumberError: "" })
                setUpdatedDetails({ ...updatedDetails, [e.target.name]: e.target.value });
            } else setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" })
        }
        if (e.target.name === 'bankIfscCode') {
            setIfscCode(e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, '').slice(0, 11));
            if (e.target.value.length > 0 && VALIDATION.ifscValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, ifscCodeError: "" })
                setbankBranch('');
            } else setErrorMessage({ ...errorMessage, ifscCodeError: "Please enter valid IFSC Code" })
        }
        if (e.target.name === 'forestDeptTotalLandAreaValue') {
            setForestDeptTotalLandAreaValue(e.target.value);
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, landAreaError: "" })
            } else setErrorMessage({ ...errorMessage, landAreaError: "Please enter plot area" })
        }
        if (e.target.name === 'forestDeptTotalLandAreaUnit') {
            setForestDeptTotalLandAreaUnit(e.target.value);
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, landAreaError: "" })
            } else setErrorMessage({ ...errorMessage, landAreaError: "Please select units" })
        }
        if (e.target.name === 'forestDeptTotalNoOfBambooClumps') {
            setForestDeptTotalNoOfBambooClumps(e.target.value);
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, clumpsError: "" })
            } else setErrorMessage({ ...errorMessage, clumpsError: "Please enter clumps" })
        }
        if (e.target.name === 'name') {
            setName(e.target.value);
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, nameError: "" })
            } else setErrorMessage({ ...errorMessage, nameError: "Please enter name" })
        }
        if (e.target.name === 'contactPersonFirstname') {
            setContactPersonFirstname(e.target.value);
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, contactPersonFirstNameError: "" })
            } else setErrorMessage({ ...errorMessage, contactPersonFirstNameError: "Please enter first name" })
        }
        if (e.target.name === 'contactPersonMiddlename') {
            setContactPersonMiddlename(e.target.value);
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, contactPersonMiddleNameError: "" })
            } else setErrorMessage({ ...errorMessage, contactPersonMiddleNameError: "Please enter middle name" })
        }
        if (e.target.name === 'contactPersonLastname') {
            setContactPersonLastname(e.target.value);
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, contactPersonLastNameError: "" })
            } else setErrorMessage({ ...errorMessage, contactPersonLastNameError: "Please enter last name" })
        }
        if (e.target.name === 'contactPersonGender') {
            setContactPersonGender(e.target.value);
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, contactPersonGenderError: "" })
            } else setErrorMessage({ ...errorMessage, contactPersonGenderError: "Please select gender" })
        }
        if (e.target.name === 'contactPersonSalutation') {
            setContactPersonSalutation(e.target.value);
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, contactPersonSalutationError: "" })
            } else setErrorMessage({ ...errorMessage, contactPersonSalutationError: "Please select salutation" })
        }
        if (e.target.name === 'address') {
            setAddress(e.target.value.slice(0, 300));
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, addressError: "" })
            } else setErrorMessage({ ...errorMessage, addressError: "Please enter address" })
        }
        if (e.target.name === 'forestDeptAddress') {
            setForestDeptAddress(e.target.value);
            if (e.target.value.length > 0) {
                setErrorMessage({ ...errorMessage, forestDeptAddressError: "" })
            } else setErrorMessage({ ...errorMessage, forestDeptAddressError: "Please enter address" })
        }
        if (e.target.name === 'mobileNo') {
            var slicedMobileNumber = mobileNumberValidation(e.target.value);
            setMobileNo(slicedMobileNumber);
            if (slicedMobileNumber.length != 10) {
                setErrorMessage({ ...errorMessage, mobileNoError: "Please enter valid mobile No" })
            } else setErrorMessage({ ...errorMessage, mobileNoError: "" })
        }
        if (e.target.name === "bankAccountNumber") {
            const limit = 18;
            if (e.target.value.length > 0 && VALIDATION.bankAccountNumberValidation(e.target.value.slice(0, limit))) {
                setUpdatedDetails({ ...updatedDetails, [e.target.name]: e.target.value.slice(0, limit) })
                setErrorMessage({ ...errorMessage, accountNumberError: '' })
            } else setErrorMessage({ ...errorMessage, accountNumberError: 'Please enter valid Account Number' })
        }
    };


    const onGovIdypeChange = (e) => {
        e.preventDefault();
        if (e.target.name === "govtIdCardType") {
            setGovIDType(e.target.value);
        }

        else if (e.target.name === 'otherGovtCardType') {
            const limit = 50;
            if (e.target.value.length > 0) {
                setOtherIdType(VALIDATION.fullNameValidation(e.target.value).slice(0, limit));
                setErrorMessage({ ...errorMessage, otherCardError: '' })
            }
            else {
                setErrorMessage({ ...errorMessage, otherCardError: 'Please enter ID Proof Name' })
            }
        }
    }

    const onClickAadharChange = (e) => {
        e.preventDefault();
        const limit = 20;
        if (govIDType === "Aadhaar ID") {
            setGovIDNumber(e.target.value.replace(/[^0-9]/gi, '').slice(0, 4))
        }
        else {
            setGovIDNumber(e.target.value.toUpperCase().replace(/[^0-9a-zA-Z]/gi, '').slice(0, limit))
        }
        if ((e.target.value).length == 0) {
            setErrorMessage({ ...errorMessage, govtIDError: 'Please enter ID number' })
        } else {
            setErrorMessage({ ...errorMessage, govtIDError: '' })
        }

    }

    const onPanNumberChange = (e) => {
        e.preventDefault();
        setPanNumber(e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, ''));
        if (e.target.value.length > 0 && VALIDATION.panNumberValidation(e.target.value)) {
            setErrorMessage({ ...errorMessage, panNumberError: "" })
            setPanNumber(e.target.value);
        } else setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" })
    }

    const onRoyaltyCharge = (e) => {
        e.preventDefault();
        const limit = 10;
        setRoyaltyCharge(e.target.value.slice(0, limit))
        // if(e.target.value.length > 0) {
        //     setErrorMessage({...errorMessage, royaltyChargeError: ""})
        // }
        // else setErrorMessage({...errorMessage, royaltyChargeError: "Please enter royal charge"})
    }

    const onFee = (e) => {
        e.preventDefault();
        const limit = 10;
        setFee(e.target.value.slice(0, limit))
        // if(e.target.value.length > 0) {
        //     setErrorMessage({...errorMessage, otherFeeError: ""})
        // }
        // else setErrorMessage({...errorMessage, otherFeeError: "Please enter royal charge"})
    }

    const onAccountNumberChange = (e) => {
        e.preventDefault();
        const limit = 17;
        setAccountNumber(e.target.value.slice(0, limit))
        if (e.target.value.length > 0 && VALIDATION.bankAccountNumberValidation(e.target.value.slice(0, limit))) {
            setErrorMessage({ ...errorMessage, accountNumberError: "" })
            setAccountNumber(e.target.value.slice(0, limit))
        } else setErrorMessage({ ...errorMessage, accountNumberError: 'Please enter valid Account Number' })
    }
    const onAccountHolderNameChange = (e) => {
        e.preventDefault();
        setAccountHolderName(VALIDATION.fullNameValidation(e.target.value))
        if (e.target.value.length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
            setErrorMessage({ ...errorMessage, accountHolderNameError: "" })
        }
        else {
            setErrorMessage({ ...errorMessage, accountHolderNameError: "Please enter Account Holder's Name" })

        }
    }
    const handleChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setUpdatedDetails({ ...updatedDetails, blockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setUpdatedDetails({ ...updatedDetails, revenueCircle: e.target.value, });
        }
    }
    const handleBambooChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setUpdatedDetails({ ...updatedDetails, plotBlockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setUpdatedDetails({ ...updatedDetails, plotRevenueCircle: e.target.value, });
        }
    }
    const getBambooUpdatedAddressData = (data) => {
        setForestDeptPincodeDetails({
            ...forestDeptpincodeDetails,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,
        })
    }
    const saveAndExitClick = (isRegistrationSubmit) => {
        save(isRegistrationSubmit, saveAndExitCallback);
    }
    const saveAndExitCallback = () => {
        if (ResourceUpdateMember.includes(userRole) && userRole === 'Reg-ITAdmin') {
            navigate("/sidebar/viewAllActiveApplications")
        }
        else if (ResourceUpdateMember.includes(userRole) && userRole === 'Res-Scmuser') {
            navigate("/resourcedashboard/searchByURN")
        }
        else navigate('/dashboardHome/dashboardStakeHolder')
    }
    const checkValidations = () => {
        if (!name || name.length == 0) {
            setErrorMessage({ ...errorMessage, nameError: "Please enter name" });
            return false
        }
        else if (!contactPersonFirstname || contactPersonFirstname.length == 0) {
            setErrorMessage({ ...errorMessage, contactPersonFirstnameError: "Please enter contact person name" });
            return false
        }
        else if (!mobileNo || mobileNo.length !== 10) {
            setErrorMessage({ ...errorMessage, mobileNoError: "Please enter valid mobile number" });
            return false
        }
        else if (!address || address.length == 0) {
            setErrorMessage({ ...errorMessage, addressError: "Please enter address" });
            return false
        }
        else if (!pincodeDetails.pincode || pincodeDetails.pincode.length == 0) {
            setErrorMessage({ ...errorMessage, pincodeError: "Please enter pincode" });
            return false
        }
        else if (!forestDeptTotalLandAreaValue || forestDeptTotalLandAreaValue.length == 0) {
            setErrorMessage({ ...errorMessage, landAreaError: "Please enter plot area" });
            return false
        }
        else if (!forestDeptTotalNoOfBambooClumps || forestDeptTotalNoOfBambooClumps.length == 0) {
            setErrorMessage({ ...errorMessage, clumpsError: "Please enter clumps" });
            return false
        }
        else if (!forestDeptAddress || forestDeptAddress.length == 0) {
            setErrorMessage({ ...errorMessage, forestDeptAddress: "Please enter plot address" });
            return false
        }
        else if (!forestDeptpincodeDetails.pincode || forestDeptpincodeDetails.pincode.length == 0) {
            setErrorMessage({ ...errorMessage, forestDeptPincodeError: "Please enter pincode" });
            return false
        }
        else if (userRole !== ROLES.ItAdmin) {
            if (govIDType == "Other" && !otherIdType) {
                setErrorMessage({ otherCardError: "Please enter ID proof type" });
                return false;
            }
            else if (!govIDNumber || govIDNumber.length == 0) {
                setErrorMessage({ govtIDError: "Please enter ID Proof Number" });
                return false;
            }
            else if (!accountNumber || accountNumber.length == 0 || !VALIDATION.bankAccountNumberValidation(accountNumber)) {
                setErrorMessage({ accountNumberError: "Please enter valid Account Number" });
                return false;
            }
            else if (!accountHolderName || accountHolderName.length == 0 || !VALIDATION.bankAccountNameValidation(accountHolderName)) {
                setErrorMessage({ accountHolderNameError: "Please enter valid Account Holder's Name" });
                return false;
            }
            else if (!ifscCode || ifscCode.length == 0 || !VALIDATION.ifscValidation(ifscCode)) {
                setErrorMessage({ ifscCodeError: "Please enter valid IFSC code and search" })
                return false;
            }
            else if (!bankBranch || bankBranch.length == 0) {
                setErrorMessage({ ifscCodeError: "Please enter valid IFSC code and search" })
                return false;
            }
            else if (panNumber && !VALIDATION.panNumberValidation(panNumber)) {
                setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" })
                return false;
            }
            // else if (!royaltyCharge || royaltyCharge.length == 0) {
            //     setErrorMessage({ ...errorMessage, royaltyChargeError: "Please enter royalty charge" })
            //     return false;
            // }
            // else if (!fee || fee.length == 0) {
            //     setErrorMessage({ ...errorMessage, otherFeeError: "Please enter fee" })
            //     return false;
            // }
            var idProofDoc = documentArray && documentArray.filter((item) => item.documentType === ID_PROOF && item.isActive == 1);
            if (idProofDoc.length == 0) {
                setErrorMessage({ idProofDocError: "Please upload ID Proof document" });
                return false;
            }
            var panDoc = documentArray && documentArray.filter((item) => item.documentType === PAN_CARD && item.isActive == 1);
            if (panNumber && panDoc.length == 0) {
                setErrorMessage({ panDocError: "Please upload pan document" });
                return false;
            }
            var bankDoc = documentArray && documentArray.filter((item) => item.documentType === BANK_CANCELLED_CHEQUE && item.isActive == 1);
            if (bankDoc.length == 0) {
                setErrorMessage({ bankDocError: "Please upload bank statemnt document" });
                return false;
            }
            var harvestingDoc = documentArray && documentArray.filter((item) => item.documentType === HARVEST_PLAN && item.isActive == 1);
            if (harvestingDoc.length == 0) {
                setErrorMessage({ harvestPlanDocError: "Please upload harvesting plan document" });
                return false;
            }
        }
        return true;
    }

    const onNextClick = (isRegistrationSubmit) => {
        save(isRegistrationSubmit, nextCallBack);
    }
    const nextCallBack = () => {
        navigate('/dashboardHome/personalDetailsForest/registrationForestDetails', { state: { URN: urn, editMode: state?.editMode, appCountDisplay: state?.appCountDisplay, bambooSpeciesRes: bambooSpeciesRes } })
    }
    const save = (isRegistrationSubmit, callback) => {
        if (!checkValidations()) {
            return false;
        }
        const forest = forestDetails?.growers[0];
        const regStakeholderMaster = forest?.regStakeholderMaster;
        const data = {
            "id": regStakeholderMaster?.id,
            "name": name,
            "contactPersonName": regStakeholderMaster?.contactPersonName,
            "contactPersonFirstname": contactPersonFirstname,
            "contactPersonMiddlename": contactPersonMiddlename,
            "contactPersonLastname": contactPersonLastname,
            "contactPersonGender": contactPersonGender,
            "contactPersonSalutation": contactPersonSalutation,
            "mobileNo": mobileNo,
            "bankAccountNumber": accountNumber,
            "bankAccountHolderName": accountHolderName,
            "bankBranch": bankBranch,
            "bankIfscCode": ifscCode,
            "bankName": bankName,
            "panNumber": panNumber,
            "govtIdCardType": govIDType,
            "govtIdCardNumber": govIDNumber,
            "otherGovtCardType": otherIdType?.otherGovtCardType,
            "emailId": regStakeholderMaster?.emailId,
            "category": regStakeholderMaster?.category,
            "stakeHolderType": regStakeholderMaster?.stakeHolderType,
            "urn": regStakeholderMaster?.urn,
            "preRegistrationShortlisted": regStakeholderMaster?.preRegistrationShortlisted,
            "registrationStatus": isRegistrationSubmit && (ResourceUpdateMember.includes(userRole) || regStakeholderMaster?.registrationStatus == "Approved") ? "ResourceUpdate" : regStakeholderMaster?.registrationStatus,
            "scrutinyStatus": regStakeholderMaster?.scrutinyStatus,
            "stakeholderStatus": regStakeholderMaster?.stakeholderStatus,
            "createdOn": regStakeholderMaster?.createdOn,
            "createdBy": regStakeholderMaster?.createdBy,
            "updatedOn": regStakeholderMaster?.updatedOn,
            "updatedBy": regStakeholderMaster?.updatedBy,
            "isActive": regStakeholderMaster?.isActive,
            "isOtpValidated": regStakeholderMaster?.isOtpValidated,
            "growerDetails": [
                {
                    "id": forest?.id,
                    "regStakeholderMasterId": forest?.regStakeholderMasterId,
                    "growerCategory": forest?.growerCategory,
                    "growerType": forest?.growerType,
                    "authorizedContactPerson": forest?.authorizedContactPerson,
                    "address": address,
                    "pincode": pincodeDetails?.pincode,
                    "state": pincodeDetails?.state,
                    "district": pincodeDetails?.district,
                    "revenueCircle": pincodeDetails?.revenueCircle,
                    "blockName": pincodeDetails?.blockName,
                    "expansionPlan": forest?.expansionPlan,
                    "aggregationPoint": forest?.aggregationPoint,
                    "aggregationPointName": forest?.aggregationPointName,
                    "aggregationPointContact": forest?.aggregationPointContact,
                    "aggregationPointPincode": forest?.aggregationPointPincode,
                    "aggregationPointAddress": forest?.aggregationPointAddress,
                    "aggregationPointState": forest?.aggregationPointState,
                    "aggregationPointDistrict": forest?.aggregationPointDistrict,
                    "aggregationPointSubDivision": forest?.aggregationPointSubDivision,
                    "aggregationPointPostOffice": forest?.aggregationPointPostOffice,
                    "readyToHarvest": forest?.readyToHarvest,
                    "locationGeocode": forest?.locationGeocode,
                    "documentId": forest?.documentId,
                    "divisionalForestOfficeName": forest?.documentId,
                    "divisionalForestOfficeAddress": forest?.divisionalForestOfficeAddress,
                    "divisionalForestOfficeContactName": forest?.divisionalForestOfficeContactName,
                    "divisionalForestOfficeContactNo": forest?.divisionalForestOfficeContactNo,
                    "forestDeptAddress": forestDeptAddress,
                    "forestDeptBlockName": forestDeptpincodeDetails?.blockName,
                    "forestDeptRevenueCircle": forestDeptpincodeDetails?.revenueCircle,
                    "forestDeptPincode": forestDeptpincodeDetails?.pincode,
                    "forestDeptState": forestDeptpincodeDetails?.state,
                    "forestDeptDistrict": forestDeptpincodeDetails?.district,
                    "forestDeptSubDivision": forest?.forestDeptSubDivision,
                    "forestDeptPostOffice": forest?.forestDeptPostOffice,
                    "forestDeptTotalLandArea": forestDeptTotalLandAreaValue + " " + forestDeptTotalLandAreaUnit,
                    "forestDeptTotalNoOfBambooClumps": forestDeptTotalNoOfBambooClumps,
                    "forestRangeOfficeName": forest?.forestRangeOfficeName,
                    "forestRangeOfficeAddress": forest?.forestRangeOfficeAddress,
                    "forestRangeOfficeContactName": forest?.forestRangeOfficeContactName,
                    "forestRangeOfficeContactNo": forest?.forestRangeOfficeContactNo,
                    "forestRangeBeatName": forest?.forestRangeBeatName,
                    "forestRangeBeatAddress": forest?.forestRangeBeatAddress,
                    "forestRangeBeatContactName": forest?.forestRangeBeatContactName,
                    "forestRangeBeatContactNo": forest?.forestRangeBeatContactNo,
                    "agreementStartDate": agreementStartDate,
                    "agreementEndDate": agreementEndDate,
                    "plotPincode": forest?.plotPincode,
                    "plotState": forest?.plotState,
                    "plotDistrict": forest?.plotDistrict,
                    "plotSubDivision": forest?.plotSubDivision,
                    "plotRevenueCircle": forest?.plotRevenueCircle,
                    "plotBlockName": forest?.plotBlockName,
                    "plotPostOffice": forest?.plotPostOffice,
                    "plotTotalLandArea": forest?.plotTotalLandArea,
                    "plotTotalNoOfBambooClumps": forest?.plotTotalNoOfBambooClumps,
                    "cooperativeName": forest?.cooperativeName,
                    "cooperativeContact": forest?.cooperativeContact,
                    "royaltyCharge": royaltyCharge,
                    "anyOtherFee": fee,
                    "createdOn": forest?.createdOn,
                    "createdBy": forest?.createdBy,
                    "updatedOn": forest?.updatedOn,
                    "updatedBy": forest?.updatedBy,
                    "isActive": forest?.isActive,
                    "growerForestRangeDetails": [],
                    "growerLandDetails": [],
                    "growerMemberDetails": [],
                    "growerDocuments": documentArray,
                }
            ]
        }
        apiClient
            .post(UPDATE_GROWER + `?IsRegistrationSubmit=${isRegistrationSubmit}`,
                data,
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }
            )
            .then((response) => {
                callback();
            })
            .catch(function (error) {
            })

    }

    const isDisabled = () => {
        if (ResourceUpdateMember.includes(userRole)) {
            if (userRole === 'Reg-ITAdmin') {
                return false;
            }
            else { return true; }
        }
        else if (forestDetails?.growers[0]?.registrationStatus === "Registered" || forestDetails?.growers[0]?.registrationStatus === "ResourceUpdate" || forestDetails?.growers[0]?.registrationStatus === "Scrutiny_Initiated") {
            if (editMode || appCountDisplay) {
                return false;
            }
            else
                return true;
        }
        else {
            return false;
        }
    }
    const isDisabledRegOnly = () => {
        if (forestDetails?.growers[0]?.registrationStatus === "Registered" || forestDetails?.growers[0]?.registrationStatus === "ResourceUpdate" || forestDetails?.growers[0]?.registrationStatus === "Scrutiny_Initiated") {
            return true;
        }
        else {
            return false;
        }
    }
    const isAdminEnable = () => {
        if (ResourceUpdateMember.includes(userRole)) {
            if (userRole === 'Reg-ITAdmin') {
                return false;
            }
            else { return true; }
        }
        else {
            if (details.mobileNo && details.contactPersonFirstname) {
                return true;
            }
            if (editMode || appCountDisplay) {
                return false;
            }
            else
                return true;
        }

    }
    const onClickVerifyMobileNo = (e) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, OTPError: "" });
        setOtpValue("");
        if (updatedDetails.mobileNo) {
            sendOTP(updatedDetails.mobileNo, callBackMobileValidation);
        }
    }

    const callBackMobileValidation = (response) => {
        if (response.isSuccess) {
            setVerifyMobileNo(true);
            setOtpHidden(false);
            setErrorMessage({ ...errorMessage, OTPError: "" });
        }
    }

    const onOtpChange = (e) => {
        const limit = 6;
        setOtpValue(e.target.value.slice(0, limit))
        if (e.target.value.length == 6) {
            validateOTP(updatedDetails.mobileNo, e.target.value, callBackOTPValidation);
        }
    }
    const callBackOTPValidation = (response) => {
        if (response.isSuccess) {
            setVerifyMobileNo(false);
            setOtpHidden(true);
            setMobileOTPValidated(true);
            setUpdatedDetails({ ...updatedDetails, isOtpValidated: true })
            setErrorMessage({ ...errorMessage, OTPError: "" });
        }
        else {
            setErrorMessage({ ...errorMessage, OTPError: INVALID_OTP_ERROR });
        }
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG29</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <BackButton navigate={navigate} />
                    <Typography variant="h5" gutterBottom>
                        {t('reg.registrationDetails')}
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} >
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <TextField fullWidth
                                            required
                                            type="text"
                                            name="name"
                                            error={errorMessage.nameError}
                                            helperText={errorMessage.nameError}
                                            disabled={isAdminEnable()}
                                            value={name || ''}
                                            onChange={(e) => handleChange(e)}
                                            label={t('reg.nameOfForestDivisionOffice')}
                                            
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            {t('preReg.contactPersonDetails')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} lg={2}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('preReg.salutation')}</InputLabel>
                                            <Select
                                                label={t('preReg.salutation')}
                                                disabled={isAdminEnable()}
                                                name='contactPersonSalutation'
                                                onChange={(e) => handleChange(e)} value={contactPersonSalutation}>
                                                {SALUTATION.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={8} lg={4}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.contactPersonFirstNameError}
                                            helperText={errorMessage.contactPersonFirstNameError}
                                            label={t('preReg.firstname')}
                                            disabled={isAdminEnable()}
                                            type="text"
                                            name="contactPersonFirstname"
                                            value={contactPersonFirstname || ''}
                                            onChange={(e) => handleChange(e)}
                                           
                                        />
                                        <BadgeComponent currentLength={contactPersonFirstname?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <TextField fullWidth
                                            type="text"
                                            error={errorMessage.contactPersonMiddlenameError}
                                            helperText={errorMessage.contactPersonMiddlenameError}
                                            disabled={isAdminEnable()}
                                            value={contactPersonMiddlename || ''}
                                            name="contactPersonMiddlename"
                                            label={t('preReg.middlename')}
                                            onChange={(e) => handleChange(e)}
                                           
                                        />
                                        <BadgeComponent currentLength={contactPersonMiddlename?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <TextField fullWidth
                                            type="text"
                                            error={errorMessage.contactPersonLastnameError}
                                            helperText={errorMessage.contactPersonLastnameError}
                                            disabled={isAdminEnable()}
                                            value={contactPersonLastname || ''}
                                            name="contactPersonLastname"
                                            label={t('preReg.lastname')}
                                            onChange={(e) => handleChange(e)}
                                            
                                        />
                                        <BadgeComponent currentLength={contactPersonLastname?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={4} lg={2}>
                                        <FormControl fullWidth required error={errorMessage?.genderError}>
                                            <InputLabel>{t('preReg.gender')}</InputLabel>
                                            <Select
                                                label={t('preReg.gender')}
                                                name='contactPersonGender'
                                                disabled={isAdminEnable()}
                                                value={contactPersonGender}
                                                onChange={(e) => handleChange(e)}
                                            >
                                                {GENDER.map((item) => <MenuItem value={item} key={item}>{item}</MenuItem>)}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage?.genderError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={8} lg={4}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.mobileNoError}
                                            helperText={errorMessage.mobileNoError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.mobileNo')}
                                            InputProps={{
                                                maxLength: 10
                                            }}
                                            name="mobileNo"
                                            disabled={isAdminEnable()}
                                            value={mobileNo || ''}
                                            onChange={(e) => handleChange(e)} />
                                            <BadgeComponent currentLength={mobileNo?.length} maxLength={mobileNoMaxLength} />
                                        {mobileOTPValidated ?
                                            <div className="commonVerifyText"><a href="#">Verified</a>
                                                <img className="commonOtpImg" src={resolveIcon} alt="" /></div>
                                            :
                                            <div hidden={mobileOTPValidated || verifyMobileNo} style={{ float: "right" }}><button className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile No.</button>
                                                <div className='errorText_storage'>{errorMessage.OTPError}</div></div>
                                        }
                                        <div hidden={otpHidden}><button className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</button></div>
                                    </Grid>
                                    <Grid item xs={3} lg={2} hidden={otpHidden}>
                                        <TextField fullWidth
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            onChange={(e) => onOtpChange(e)}
                                            value={otpValue}
                                            label={t('preReg.otp')} />
                                            <BadgeComponent currentLength={otpValue?.length} maxLength={otpMaxLength} />
                                    </Grid>
                                    <Grid item xs={12} lg={6}>
                                        <TextField fullWidth
                                            error={errorMessage?.addressError}
                                            helperText={errorMessage?.addressError}
                                            disabled={isAdminEnable()}
                                            type="text"
                                            name="address"
                                            label={t('main.officeAddressTitle')}
                                            value={address || ''}
                                            onChange={(e) => handleChange(e)}
                                            
                                        />
                                        <BadgeComponent currentLength={address?.length} maxLength={addressMaxLength} />
                                    </Grid>
                                    <CommonPincodeMUI setErrorMessage={setErrorMessage} 
                                        fullWidth={true}
                                        isDisabled={isAdminEnable()}
                                        pincode={pincodeDetails.pincode}
                                        state={pincodeDetails.state}
                                        district={pincodeDetails.district}
                                        revenueCircle={pincodeDetails.revenueCircle}
                                        blockName={pincodeDetails.blockName}
                                        onHandleCallback={getUpdatedAddressData}
                                        pincodeError={errorMessage.pincodeError}
                                        searchError={errorMessage.searchError}
                                        handleChangeSelect={handleChangeSelect}
                                    />
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('preReg.idProof')}</InputLabel>
                                            <Select
                                                value={govIDType}
                                                disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled()}
                                                onChange={(e) => onGovIdypeChange(e)}
                                                name="govtIdCardType" label={t('preReg.idProof')}>
                                                {CONSTANTS.ID_PROOF_ARRAY.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                        <FileUploadMUI key="idProof"
                                            documentList={documentArray}
                                            documentType={ID_PROOF}
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={forestDetails?.growers[0].id}
                                            title={t('reg.uploadIDProofDoc')}
                                            stakeHolderType="growerForest"
                                            disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled()}
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="idProofDocError"
                                        />
                                        {/* <div className='mandatory_field'>{errorMessage.idProofDocError}</div> */}
                                    </Grid>
                                    {govIDType == "Other" && <Grid item xs={12} lg={4}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.otherCardError}
                                            helperText={errorMessage.otherCardError}
                                            disabled={isDisabled()}
                                            type="text"
                                            label={t('preReg.enterIdProof')}
                                            name="otherGovtCardType"
                                            defaultValue={otherIdType}
                                            onChange={(e) => onGovIdypeChange(e)} />
                                    </Grid>}
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.govtIDError}
                                            helperText={errorMessage.govtIDError}
                                            disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled()}
                                            value={govIDNumber}
                                            onChange={(e) => onClickAadharChange(e)}
                                            label={govIDType === "MOA" ? t('preReg.enterMOA') : govIDType === "Registration Certificate" ? t('preReg.enterRegNo') : govIDType === "GST" ? t('preReg.enterGSTNo') : t('preReg.enterNo')}
                                            InputProps={{
                                                style: { textTransform: "uppercase" }
                                            }} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.panNumberError}
                                            helperText={errorMessage.panNumberError}
                                            disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled()}
                                            type="text"
                                            label={t('preReg.enterPanNo')}
                                            value={panNumber}
                                            InputProps={{
                                                maxLength: 10,
                                                style: { textTransform: "uppercase" }
                                            }}
                                            onChange={(e) => onPanNumberChange(e)} />
                                        <FileUploadMUI key="pan"
                                            documentList={documentArray}
                                            documentType={PAN_CARD}
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={forestDetails?.growers[0].id}
                                            title={t('preReg.uploadPanDoc')}
                                            stakeHolderType="growerForest"
                                            disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled()}
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="panDocError"
                                       />
                                        {/* <div className='mandatory_field'>{errorMessage.panDocError}</div> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Divider sx={{
                                width: '105%',
                                bgcolor: "black",
                                marginTop: '3vh',
                                color: 'red'
                            }} mt={2} />
                            <Grid item xs={12} >
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            {t('preReg.bankDetails')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.accountNumberError}
                                            helperText={errorMessage.accountNumberError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            name="bankAccountNumber"
                                            label={t('preReg.accountNo')}
                                            disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled()}
                                            value={accountNumber}
                                            onChange={(e) => onAccountNumberChange(e)}
                                            onKeyDown={(evt) => typeNumberValid(evt)} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.accountHolderNameError}
                                            helperText={errorMessage.accountHolderNameError}
                                            type="text"
                                            name="bankAccountHolderName"
                                            label={t('preReg.accountHolderName')}
                                            disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled()}
                                            value={accountHolderName}
                                            onChange={(e) => onAccountHolderNameChange(e)}
                                            InputProps={{
                                                maxLength: 30
                                                
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.ifscCodeError}
                                            helperText={errorMessage.ifscCodeError}
                                            disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled()}
                                            type="text"
                                            name="bankIfscCode"
                                            label={t('preReg.ifscCode')}
                                            value={ifscCode || ''}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === '.' || evt.key === '-') && evt.preventDefault()}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton color='primary' aria-label="delete" disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled()} onClick={() => getBankDetails()}>
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                                maxLength: 11,
                                                style: { textTransform: "uppercase" }
                                            }}
                                        ></TextField>
                                    </Grid>
                                    <Grid item xs={12} lg={5}>
                                        <TextField fullWidth
                                            disabled
                                            type="text"
                                            name="bankBranch"
                                            label={t('preReg.branch')}
                                            value={bankBranch}
                                            onChange={(e) => handleChange(e)}
                                        />
                                        <FileUploadMUI key="bankproof"
                                            documentList={documentArray}
                                            documentType={BANK_CANCELLED_CHEQUE}
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={forestDetails?.growers[0].id}
                                            title={t('preReg.uploadPassbookCancelledCheck')}
                                            stakeHolderType="growerForest"
                                            disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled()}
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="bankDocError"
                                        />
                                        {/* <div className='mandatory_field'>{errorMessage.bankDocError}</div> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Divider sx={{
                                width: '105%',
                                bgcolor: "black",
                                marginTop: '3vh',
                                color: 'red'
                            }} mt={2} />
                            <Grid item xs={12} >
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            {t('preReg.agreementDetails')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                required
                                                label={t('reg.startDate')}
                                                inputFormat="DD/MM/YYYY"
                                                value={agreementStartDateDisplay}
                                                name="agreementStartDate"
                                                onChange={(e) => handleDateChange(e, "agreementStartDate")}
                                                disabled={isDisabledRegOnly()}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.agreementStartDateError}</FormHelperText>
                                        </LocalizationProvider>
                                        <FileUploadMUI fullWidth={true} key="agreement"
                                            documentList={documentArray}
                                            documentType={LOI_ABRPL_AGREEMENT}
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={forestDetails?.growers[0].id}
                                            title={t('reg.uploadLOI&AgreementDoc')}
                                            disabled={isDisabledRegOnly()}
                                            errorMessage={errorMessage}
                                                    setErrorMessage={setErrorMessage}
                                                    documentError="agreementdocError"
                                        />
                                        {/* <div className='mandatory_field'>{errorMessage.idProofDocError}</div> */}
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                required
                                                label={t('reg.endDate')}
                                                inputFormat="DD/MM/YYYY"
                                                value={agreementEndDateDisplay}
                                                name="agreementEndDate"
                                                minDate={agreementStartDateDisplay}
                                                onChange={(e) => handleDateChange(e, "agreementEndDate")}
                                                disabled={isDisabledRegOnly()}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.agreementEndDateError}</FormHelperText>
                                        </LocalizationProvider>
                                        <FileUploadMUI fullWidth={true} key="harvest_plan"
                                            documentList={documentArray}
                                            documentType={HARVEST_PLAN}
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={forestDetails?.growers[0].id}
                                            title={t('reg.uploadHarvestingPlanDoc')}
                                            stakeHolderType="growerForest"
                                            disabled={isDisabledRegOnly()}
                                            errorMessage={errorMessage}
                                                    setErrorMessage={setErrorMessage}
                                                    documentError="harvestPlanDocError"
                                            />
                                        {/* <div className='mandatory_field'>{errorMessage.harvestPlanDocError}</div> */}
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <TextField fullWidth
                                            required
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            value={royaltyCharge}
                                            onKeyDown={(evt) => typeNumberValid(evt)}
                                            onChange={(e) => onRoyaltyCharge(e)}
                                            label={t('reg.royaltyCharge')}
                                            InputProps={{
                                                maxLength: 10
                                            }}
                                            disabled={isDisabledRegOnly()}
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <TextField fullWidth
                                            required
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            value={fee || ''}
                                            onKeyDown={(evt) => typeNumberValid(evt)}
                                            onChange={(e) => onFee(e)}
                                            label={t('reg.otherFees')}
                                            InputProps={{
                                                maxLength: 10
                                            }}
                                            disabled={isDisabledRegOnly()}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Divider sx={{
                                width: '105%',
                                bgcolor: "black",
                                marginTop: '3vh',
                                color: 'red'
                            }} mt={2} />
                            <Grid item xs={12} >
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            {t('preReg.bambooDetails')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <TextField fullWidth
                                            error={errorMessage.landAreaError}
                                            helperText={errorMessage.landAreaError}
                                            disabled={isAdminEnable()}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.totalPlotArea')}
                                            min="0"
                                            name="forestDeptTotalLandAreaValue"
                                            value={forestDeptTotalLandAreaValue}
                                            onKeyDown={(evt) => typeNumberValid(evt)} onChange={(e) => handleChange(e)}
                                            InputProps={{
                                                endAdornment: (
                                                    <Select
                                                        variant="standard"
                                                        size="small"
                                                        disabled={isAdminEnable()}
                                                        value={forestDeptTotalLandAreaUnit}
                                                        name="forestDeptTotalLandAreaUnit"
                                                        onChange={(e) => handleChange(e)}>
                                                        {LAND_AREA_UNIT.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                                    </Select>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <TextField fullWidth
                                            disabled={isAdminEnable()}
                                            error={errorMessage.clumpsError}
                                            helperText={errorMessage.clumpsError}
                                            value={forestDeptTotalNoOfBambooClumps || ''}
                                            name="forestDeptTotalNoOfBambooClumps"
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.totalClumps')}
                                            onKeyDown={(evt) => typeNumberValid(evt)}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    <Grid item xs={12} lg={6}>
                                        <TextField fullWidth
                                            disabled={isAdminEnable()}
                                            error={errorMessage.forestDeptAddressError}
                                            helperText={errorMessage.forestDeptAddressError}
                                            type="text"
                                            label={t('preReg.plotAddress')}
                                            multiline
                                            name="forestDeptAddress"
                                            
                                            value={forestDeptAddress || ''}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    <CommonPincodeMUI setErrorMessage={setErrorMessage} 
                                        fullWidth={true}
                                        pincode={forestDeptpincodeDetails.pincode}
                                        state={forestDeptpincodeDetails.state}
                                        district={forestDeptpincodeDetails.district}
                                        revenueCircle={forestDeptpincodeDetails.revenueCircle}
                                        blockName={forestDeptpincodeDetails.blockName}
                                        isDisabled={isAdminEnable()}
                                        onHandleCallback={getBambooUpdatedAddressData}
                                        pincodeError={errorMessage.forestDeptPincodeError}
                                        handleChangeSelect={handleBambooChangeSelect} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button
                        sx={{ minWidth: 100 }}
                        variant="contained"
                        onClick={() => saveAndExitClick(false)} disabled={isDisabledRegOnly()} >{t('preReg.save&exit')}</Button>
                    <Button
                        sx={{ minWidth: 100, ml: 1 }}
                        variant="contained"
                        onClick={() => onNextClick(false)}>{t('preReg.next')}</Button>
                </Box>
            </Container>
        </>
    )
}

export default PersonalDetailsForest;